import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=0a7cbba5&"
import script from "./Join.vue?vue&type=script&lang=ts&"
export * from "./Join.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports